import { ContextMenuPopover } from "../../../components/ContextMenuPopover";
import { Copy03, Trash04 } from "untitledui-js-base";
import { FC } from "react";
import { Template } from "types/landlord/verificationTemplate";
import moment from "moment";
import { useTemplateContext } from "../provider";

interface Props {
  template?: Template;
  onDuplicate?: () => void;
  onDelete?: () => void;
}

interface InfoItem {
  label?: string;
  value?: string;
  isDivider?: boolean;
}

export const TemplateMenu: FC<Props> = ({
  template,
  onDelete,
  onDuplicate
}) => {
  const { readOnly } = useTemplateContext();

  const formatDateTime = (date?: string) =>
    date ? moment(date).format("MMM D, YYYY [at] h:mm a") : "";

  const infoData: InfoItem[] = [
    template?.updated_at && {
      label: "Last modified",
      value: formatDateTime(template.updated_at)
    },
    template?.updated_by?.name && {
      label: "Modified by",
      value: template.updated_by.name
    },
    { isDivider: true },
    template?.created_at && {
      label: "Created at",
      value: moment(template.created_at).format("MMM D, YYYY [at] h:mm a")
    },
    template?.created_by?.name && {
      label: "Created by",
      value: template.created_by.name
    }
  ].filter(Boolean) as InfoItem[];

  const infoSection = (
    <div className="w-80 py-4">
      {infoData.map(({ label, value, isDivider }, index) =>
        isDivider ? (
          <div
            key={`divider-${index}`}
            className="border-t border-alpha-40 pt-4 mt-4"
          />
        ) : (
          <div
            key={label || `item-${index}`}
            className="flex justify-between text-content-400 text-xs pb-1"
          >
            <p>{label}</p>
            <p>{value}</p>
          </div>
        )
      )}
    </div>
  );

  return (
    <ContextMenuPopover
      contentClassName="!z-50"
      borderLess={false}
      actions={[
        ...(readOnly
          ? []
          : [
              {
                title: (
                  <span className="flex gap-3 items-center">
                    <Copy03 size="20" className="stroke-content-200" />
                    Duplicate
                  </span>
                ),
                onClick: () => onDuplicate?.()
              },
              {
                title: (
                  <span className="flex gap-3 items-center text-danger-500">
                    <Trash04 size="20" className="stroke-danger-500" />
                    Delete template
                  </span>
                ),
                onClick: () => onDelete?.()
              }
            ]),
        {
          title: infoSection,
          disabled: true,
          className: "border-t border-alpha-100",
          onClick: () => {}
        }
      ]}
      placement="bottom-start"
    />
  );
};
